import { render, staticRenderFns } from "./crudZones.vue?vue&type=template&id=50cd265f&"
import script from "./crudZones.vue?vue&type=script&lang=js&"
export * from "./crudZones.vue?vue&type=script&lang=js&"
import style0 from "./crudZones.vue?vue&type=style&index=0&id=50cd265f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports